import type { Entregador, FiltroStatusRota, PedidoRoteirizavel } from "../../../services/roteirizacao"
import { FILTRO_STATUS_PADRAO, LIMITE_PADRAO_ROTEIRIZACAO } from "../../../services/roteirizacao"

export type { Entregador, FiltroStatusRota, PedidoRoteirizavel }

export type ProvedorMapa = "google" | "mapbox"

/** Chave onde o último filtro de status fica salvo (mantido ao trocar de tela). */
export const CHAVE_FILTRO_STATUS = "roteirizacaoFiltroStatus"

/** Lê o último filtro salvo em localStorage, mesclado com o padrão. */
export function carregarFiltroStatus(): FiltroStatusRota {
    try {
        const bruto = localStorage.getItem(CHAVE_FILTRO_STATUS)
        if (bruto) {
            const salvo = JSON.parse(bruto) as Partial<FiltroStatusRota>
            return { ...FILTRO_STATUS_PADRAO, ...salvo }
        }
    } catch {
        /* ignore */
    }
    return { ...FILTRO_STATUS_PADRAO }
}

export interface RoteirizacaoModel {
    /** Pedidos de delivery do dia selecionado. */
    pedidos: PedidoRoteirizavel[]
    /** Entregadores cadastrados ativos. */
    entregadores: Entregador[]
    /** Dia consultado, no formato dd/mm/aaaa. */
    data: string
    /** Filtro de quais status aparecem no mapa/lista. */
    filtroStatus: FiltroStatusRota
    /** Entregador escolhido para a próxima associação. */
    entregadorSelecionadoId: number | null
    /** Ids dos pedidos marcados para roteirizar. */
    pedidosSelecionados: number[]
    /** Pedidos roteirizados já contabilizados. */
    usados: number
    /** Teto de pedidos roteirizados. */
    limite: number
    /** Assinatura possui o recurso ROTEIRIZACAO => roteirizações ilimitadas (ignora o teto). */
    ilimitado: boolean
    /** id do registro do contador em ParametroGeral (null se ainda não criado). */
    idParametroContador: number | null
}

function dataHoje(): string {
    const hoje = new Date()
    const dd = String(hoje.getDate()).padStart(2, "0")
    const mm = String(hoje.getMonth() + 1).padStart(2, "0")
    const yyyy = hoje.getFullYear()
    return `${dd}/${mm}/${yyyy}`
}

export const RoteirizacaoInicial: RoteirizacaoModel = {
    pedidos: [],
    entregadores: [],
    data: dataHoje(),
    filtroStatus: carregarFiltroStatus(),
    entregadorSelecionadoId: null,
    pedidosSelecionados: [],
    usados: 0,
    limite: LIMITE_PADRAO_ROTEIRIZACAO,
    ilimitado: false,
    idParametroContador: null,
}
